import { DictationScript } from "../engines/dictation/dictation-script";
import { EngineTypes } from "./engine-types";

export const ENGINE_SCRIPTS = {
    [EngineTypes.DICTATION]: DictationScript,
    [EngineTypes.CLASSIC]: null
}
